module.exports = __webpack_public_path__ + "img/en-gb.18b8ee10.svg";